export const SHOW_RULES = 'SHOW_RULES';
export const HIDE_RULES = 'HIDE_RULES';
